module.exports = __webpack_public_path__ + "static/media/view short leave.1018daf6.svg";